<template>
    <div class="post-container">
        <!-- GRAY CONTAINER -->
        <div class="gray-container">
            <!-- COVER -->
            <div
                v-if="response.Cover"
                class="cover-img"
                :style="{ 'background-image': 'url(' + URL + '/' + response.Cover + ')' }"
            >
                <img @click="back" class="back" :src="Back" alt="Back">
            </div>

            <!-- BODY -->
            <div class="body">                    
                <!-- TITLE -->
                <div class="post-titles">
                    <!-- Type -->
                    <div class="type" v-if="response.Type == 'business'">
                        <small id="type">دسته: </small>
                        <img :src="KasboKar" class="icon"  alt="Type">
                        <small id="type">کسب و کار</small>
                    </div>
                    <div class="type" v-else-if="response.Type == 'crypto'">
                        <small id="type">دسته: </small>
                        <img :src="ArzeDigital" class="icon"  alt="Type">
                        <small id="type">ارز دیجیتال</small>
                    </div>
                    <div class="type" v-else-if="response.Type == 'financial'">
                        <small id="type">دسته: </small>
                        <img :src="Tax" class="icon"  alt="Type">
                        <small id="type">مالی و مالیاتی</small>
                    </div>

                    <!-- Date -->
                    <small id="date" >تاریخ انتشار: {{ response.Created_at  | moment }}</small>
                </div>

                <!-- MAIN -->
                <div class="main">
                    <h4>{{ response.Title }}</h4>
                    <div v-html="response.Desc"></div>
                    <!-- <p :style="{ whiteSpace: 'pre-wrap', textAlign: doesSupport() ? 'right' : 'justify'}">{{ response.Desc }}</p> -->
                </div>
            </div>

            <!-- FOOTER -->
            <div class="post-footer">
                <h5 v-if="response.LikesCount <= 0">هیچکس این مطلب را نپسندیده.</h5>
                <h5 v-else-if="response.LikesCount == 1">یک نفر این مطلب را پسندیده.</h5>
                <h5 v-else-if="response.LikesCount">{{ response.LikesCount }} نفر این مطلب را پسندیده اند.</h5>
                <p>امیدواریم که برای شما هم مفید بوده باشه...</p>

                <template>
                    <i v-if="notLiked" class="fas fa-heart like-post" @click="Like"></i>
                    <i v-else class="fas fa-heart unlike-post" @click="Unlike"></i>
                </template>

                <div class="options">
                    <div class="option">
                        <img :src="Comment" alt="Comment">
                        <button @click="CommentPopUp" class="btn btn-outline-dark">ثبت نظر</button>
                    </div>
                    <div class="seperator"></div>
                    <div class="option">
                        <img :src="Share" alt="Share">
                        <button @click="CopyCheck" class="btn btn-outline-dark">به اشتراک گذاری</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- COMMENTs -->
        <div class="comments">
            <!-- COUNTER -->
            <div class="counter">
                <span id="counter">نظرات ({{ response.CommentsCount }})</span>
            </div>

            <!-- NO COMMENT -->
            <div 
                class="no-comment"
                v-if="response.CommentsCount <= 0"
            >
                <h5>تا کنون نظری ثبت نگردیده است.</h5>
            </div>
            <!-- COMMENT ITEMs -->
            <template
                v-else
                v-for="(c, i) in response.Comments"
            >
                <div class="comment" :key="i + '-comment'" v-if="!c.isRemoved">
                    <div class="profile-container"
                        
                        :style="{ 'background-image': 'url(' + ProfileBG + ')' }"
                    >
                        <div class="profile-pic"
                            :style="{ 'background-image': 'url(' + URL + '/' + (c.CommentOwner || {}).ProfilePic + ')' }"
                        ></div>
                    </div>
                    <div class="left">
                        <span class="title">{{ (c.CommentOwner || {}).FirstName }} نوشته:</span>
                        <span class="time">{{ c.Created_at | untilNow }} </span>
                        <p class="text">{{ c.Text }} </p>
                    </div>
                </div>
                <div class="comment comment-answer" :key="i + '-answer'" v-if="c.Answer && !c.isRemoved">
                    <span class="title">در جواب «{{ (c.CommentOwner || {}).FirstName }}» نوشته:</span>
                    <p class="text">{{ c.Answer }} </p>
                </div>
            </template>
        </div>

        <!-- FAVORITE POSTs -->
        <FavoritePosts :resultList="resultList"></FavoritePosts>

        <!-- Modals -->
        <comment-modal :AddComment="AddComment"/>
    </div>
</template>

<script>
import Tax from '@/assets/images/result-types/tax.png';
import KasboKar from '@/assets/images/result-types/kasbo_kar.png';
import ArzeDigital from '@/assets/images/result-types/arze_digital.png';
import Back from '@/assets/images/courses/content/back.png';
import ProfileBG from '@/assets/images/courses/profile-wbg.png';

import Share from '@/assets/images/khanesh/share.png';
import Comment from '@/assets/images/khanesh/comment.png';

import CommentModal from '@/components/modals/comment_modal';
import FavoritePosts from '@/components/FavoritePosts';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import moment from 'moment-jalaali';
import Cookies from 'js-cookie';

export default {
    name: 'Post',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Tax: Tax,
            KasboKar: KasboKar,
            ArzeDigital: ArzeDigital,
            Back: Back,
            ProfileBG: ProfileBG,

            Share: Share,
            Comment: Comment,

            prevRoute: {},
            URL: APP_API_URL(),

            response: {},
            notLiked: true,

            token: Cookies.get('access_cookie'),
            resultList: []
        }
    },
    watch: {
        '$route': {
            handler: function() {
                this.GetAll()
                this.getPosts()
            },
            immediate: true
        }
    },
    filters: {
        // will show the date like 'Jun 24th 2020'
        moment: (date) => {
            return moment(date).format('jDD/jMMMM/jYYYY');
        },
        untilNow: (date) => {
            return moment(date).fromNow();
        }
    },
    components: {
        CommentModal,
        FavoritePosts
    },
    methods: {
        // detects if user has mobile browser or not.
        doesSupport() {
            // first get the size from the window
            // if that didn't work, get it from the body
            // let width = (window.innerWidth || document.body.clientWidth) < 768;

            // the user agent string for the current browse
            let userAgent = /iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)

            // return (width || userAgent) ? true : false;
            return userAgent ? true : false;
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        },
        getPosts() {
            getRequest('/posts/find-favorites', {})
                .then((rsp) => {
                    // response
                    this.resultList = rsp['data']
                })
                .catch(() => {
                    // error
                });
        },
        // get Post data
        GetAll() {
            getRequest('/posts/find-one', { id: this.$route.params.id})
                .then(rsp => {
                    // response
                    this.response = rsp['data'].post;
                    this.notLiked = rsp['data'].NotLiked;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        Like() {
            postRequest('/posts/like-post', { id: this.$route.params.id})
                .then(rsp => {
                    // response
                    this.response = rsp['data'];
                    this.notLiked = false;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        Unlike() {
            postRequest('/posts/unlike-post', { id: this.$route.params.id})
                .then(rsp => {
                    // response
                    this.response = rsp['data'];
                    this.notLiked = true;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        CommentPopUp() {
            this.$modal.show('comment-modal');
        },
        AddComment(comment) {
            if (!Cookies.get('access_cookie')) {
                this.$router.push({ name: 'Login' });
            } else {
                postRequest('/posts/add-comment', { 
                    id: this.$route.params.id,
                    text: comment
                })
                    .then(() => {
                        // response
                        this.GetAll();
                    })
                    .catch(err => {
                        // check auth
                        if (err.response) {
                            if (err.response.status == 401) {
                                Cookies.remove('access_cookie');
                                this.$router.push({ name: 'Login' });
                            }
                        }
                    });
            }
        },
        CopyCheck() {
            this.$modal.show('dialog', {
                title: 'سلام!',
                text: 'آیا مایل هستید آدرس خوانش جاری را جهت اشتراک گذاری در کیبورد خود کپی کنید؟',
                buttons: [
                    {
                        title: 'بلی',
                        handler: () => { 
                            this.copyToClipboard();
                            this.$modal.hide('dialog');
                        }
                    },
                    {
                        title: 'خیر',
                        default: true,
                    }
                ]
            });
        },
        copyToClipboard() {
            let URL = document.location.origin + '/khanesh/' + this.$route.params.id

            const el = document.createElement('textarea');  // Create a <textarea> element
            
            el.value = URL;                               // Set its value to the string that you want copied
            el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
            el.style.position = 'absolute';                 
            el.style.left = '-9999px';                      // Move outside the screen to make it invisible
            document.body.appendChild(el);                  // Append the <textarea> element to the HTML document

            el.select();                                    // Select the <textarea> content
            document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)

            document.body.removeChild(el);                  // Remove the <textarea> element
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.post-container {
    background-color: #fff;
}
.post-container .gray-container {
    margin-bottom: 25pt;
    padding: 10pt 0 5pt;

    border-bottom-left-radius: 25pt;
    border-bottom-right-radius: 25pt;
    background-color: #ebecf1;
}
.post-container .gray-container .back {
    height: 25pt;

    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}

/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.post-container .cover-img {
    height: 40vh;
    max-height: 300pt;
    width: 100%;

    margin-top: -10pt;
    margin-bottom: -33pt;

    position: relative;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

/* ---------------------------------------- */
/* ----------------- BODY ----------------- */
/* ---------------------------------------- */
.post-container .body {
    width: calc(100% - 20pt);
    margin: 0 auto;

    position: relative;
    z-index: 1;

    border-radius: 25pt;
    background-color: #fff;
}

/* ---------------------------------------- */
/* -------------- POST TITLES ------------- */
/* ---------------------------------------- */
.post-container .body .post-titles {
    height: fit-content;
    width: 100%;

    padding: 7pt 10pt;
    position: relative;
    top: 0;

    border-bottom: 1px solid #ddd;

    display: flex;
    flex-direction: row;
}
.post-container .body .post-titles .type {
    margin-left: auto;
}
.post-container .body .post-titles small {
    display: inline-block;
}
.post-container .body .post-titles .icon {
    max-height: 17pt;
    max-width: 17pt;

    margin: auto 0;
}
.post-container .body .post-titles #date {
    margin: auto 5px auto 25pt;
}
.post-container .body .post-titles #type {
    margin: auto 5px auto 15px;
}
@media (max-width: 576px) {
    .post-container .body .post-titles {
        padding: 7pt 5pt;
    }
    .post-container .body .post-titles .icon {
        max-height: 15pt;
        max-width: 15pt;
    }
    .post-container .body .post-titles #date {
        margin: auto 5px auto 5pt;
        font-size: 70%;
    }
    .post-container .body .post-titles #type {
        margin: auto 5px auto 10px;
        font-size: 70%;
    }
}

/* ---------------------------------------- */
/* --------------- POST MAIN -------------- */
/* ---------------------------------------- */
.post-container .body .main {
    color: #86888e;
    padding: 10pt 15pt;
}
.post-container .body .main h4 {
    color: #373b48;
}
.post-container .body .main p {
    color: #86888e;
}

/* ---------------------------------------- */
/* -------------- POST FOOTER ------------- */
/* ---------------------------------------- */
.post-container .post-footer {
    text-align: center;
    padding-top: 20pt;
}
.post-container .post-footer .like-post {
    color: #86888e;
}
.post-container .post-footer .unlike-post {
    color: #f10000;
}

.post-container .post-footer .like-post,
.post-container .post-footer .unlike-post {
    cursor: pointer;
    font-size: 2.5rem;
}

/* ---------------------------------------- */
/* ------------- POST OPTIONS ------------- */
/* ---------------------------------------- */
.post-container .post-footer .options {
    display: flex;
    padding: 10pt 0;
}
.post-container .post-footer .options .seperator {
    height: 75pt;
    margin: auto;

    border: 1px solid #666;
}
.post-container .post-footer .options .option {
    width: calc(50% - 20pt);
    max-width: 200pt;
    margin: 10pt auto;

    display: flex;
    flex-direction: column;
}
.post-container .post-footer .options .option img {
    height: 2rem;
    margin: 5pt auto 10pt;
    display: block;
}
.post-container .post-footer .options .option button {
    width: 100pt;
    padding-left: 1rem;
    padding-right: 1rem;
    margin: 0 auto;

    font-size: 90%;
    border-radius: 1rem;
}

/* ---------------------------------------- */
/* --------------- COMMENTs --------------- */
/* ---------------------------------------- */
.post-container .comments .counter {
    width: fit-content;
    padding: .5rem 1rem .5rem 1.5rem;

    font-weight: bold;
    background-color: #ebecf1;
    border-top-left-radius: 2rem;
}
.post-container .comments .comment,
.post-container .comments .no-comment {
    border-top: 1px solid #777;
    background-color: #fff;
}
.post-container .comments .comment {
    padding: 1rem .5rem;
    position: relative;

    display: flex;
}
.post-container .comments .comment-answer {
    flex-wrap: wrap;
    border-top: none;
    background-color: #efefef;
}
.post-container .comments .comment .left {
    display: flex;
    flex-wrap: wrap;
    
    width: calc(100% - 60pt);
}
.post-container .comments .comment .profile-container {
    height: 45pt;
    width: 45pt;
    border-radius: 25pt;

    float: right;
    margin-left: 10pt;

    display: flex;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.post-container .comments .comment .profile-pic {
    height: calc(100% - 8pt);
    width: calc(100% - 8pt);
    margin: auto;
    border-radius: 25pt;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.post-container .comments .comment .time {
    margin: auto;
    margin-left: 0;
}
.post-container .comments .comment .text {
    width: 100%;
    margin: .5rem 0;
}
.post-container .comments .no-comment {
    min-height: 100pt;
    display: flex;
}
.post-container .comments .no-comment h5 {
    margin: auto;
    color: #86888e;
}

/* ---------------------------------------- */
/* --------------- POST MAIN -------------- */
/* -------------- POST FOOTER ------------- */
/* --------------- COMMENTs --------------- */
/* ---------------------------------------- */
.post-container .comments .comment .time,
.post-container .comments .comment .text,
.post-container .post-footer p {
    color: #86888e;
}
@media (max-width: 576px) { 
    .post-container .body .main h4,
    .post-container .post-footer h5 {
        font-size: 1.25rem;
    }
    .post-container .body .main p {
        font-size: 70%;
    }
    .post-container .comments .comment .title,
    .post-container .comments .comment .time,
    .post-container .comments .comment .text,
    .post-container .post-footer p {
        font-size: 80%;
    }
}
</style>
